import { initCartSummary } from "./init-cart-summary";
const initCartQuantity = () => {
  const cartItems = document.querySelectorAll('[data-cart-item]');

  cartItems.forEach((item) => {
    const input = item.querySelector('[data-quantity-input]');
    const price = item.querySelector('[data-cart-item-price]');

    if (!input) {
      return;
    }

    let timeout;
    let confirmedValue = Number(input.value) || 1;

    const updateQuantity = () => {
      clearTimeout(timeout);

      timeout = setTimeout(async () => {
        const quantity = Math.max(1, Number(input.value) || 1);

        const body = new URLSearchParams({
          action: 'update_cart_item_quantity',
          nonce: wooSettings.updateCartNonce,
          cart_item_key: item.dataset.cartItemKey,
          quantity: quantity.toString(),
        });

        item.classList.add('is-loading');

        try {
          const response = await fetch(wooSettings.ajaxUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            credentials: 'same-origin',
            body,
          });

          const result = await response.json();

          if (!result.success) {
            throw new Error('Не удалось изменить количество товара');
          }

          confirmedValue = result.data.quantity;
          input.value = result.data.quantity;

          if (price) {
            price.innerHTML = result.data.itemSubtotal;
          }

          document.querySelectorAll('.header__cart-value').forEach((counter) => {
            counter.textContent = result.data.cartCount;
          });
          initCartSummary();

        } catch (error) {
          input.value = confirmedValue;
          input.dispatchEvent(new Event('change', {bubbles: true}));

          console.error(error);
        } finally {
          item.classList.remove('is-loading');
        }
      }, 300);
    };

    input.addEventListener('input', updateQuantity);
  });
};

export {initCartQuantity};